export default __webpack_public_path__ + "static/scene-one-2801468d76a57e411f769afffd2175b1.svg";